import { render, staticRenderFns } from "./ProviderSearchDashboardItemSba.vue?vue&type=template&id=24de9ad9&scoped=true"
import script from "./ProviderSearchDashboardItemSba.vue?vue&type=script&lang=js"
export * from "./ProviderSearchDashboardItemSba.vue?vue&type=script&lang=js"
import style0 from "./ProviderSearchDashboardItemSba.vue?vue&type=style&index=0&id=24de9ad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24de9ad9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VCardText,VCol,VForm,VIcon,VRow,VTextField,VTooltip})
